import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Navbar from './components/Navbar';
import SearchHighlighter from './components/SearchHighlighter';
import Portfolio from './pages/Portfolio';
import { trackPageView } from './utils/analytics';
import Blog from './pages/Blog';
import ChessGame from './pages/ChessGame';
import { enableBlog } from './config/siteFeatures';

function App() {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(path);
  }, [location.pathname, location.search, location.hash]);

  return (
    <ThemeProvider>
      <div className="App">
        <Navbar />
        <SearchHighlighter />
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/about" element={<Navigate to="/#about" replace />} />
          <Route path="/projects" element={<Navigate to="/#projects" replace />} />
          <Route path="/resume" element={<Navigate to="/#about" replace />} />
          <Route path="/contact" element={<Navigate to="/#contact" replace />} />
          <Route path="/blog" element={enableBlog ? <Blog /> : <Navigate to="/" replace />} />
          <Route path="/chess" element={<ChessGame />} />
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
